import Radium from "radium";
import React from "react";

import { styles } from "@common/styles";

export interface IPaginationProps {
  skip: number;
  skipCount: number;
  userCount: number;
  onPagination: (currSkip) => void;
}

const pagination = ({
  skipCount,
  userCount,
  skip,
  onPagination
}: IPaginationProps) => {
  const pageSize = skipCount || 20;
  const hasMoreUsers = userCount > (skip ? skip : 0) + pageSize;
  const prevPage = (skip ? skip : 0) - pageSize;
  const nextPage = (skip ? skip : 0) + pageSize;

  return (
    <div className="paginateWrapper" style={styles.paginateWrapper}>
      <PaginationPrevious
        show={skip > 0}
        onClick={() => onPagination(prevPage >= 0 ? prevPage : 0)}
      />

      <PaginationNext
        show={hasMoreUsers}
        onClick={() => onPagination(nextPage)}
      />
    </div>
  );
};

const PaginationPrevious = ({ show, onClick }) => {
  const paginateLinkPrevStyle = { ...styles.paginateLink, marginRight: 10 };

  return show ? (
    <div style={paginateLinkPrevStyle as any} onClick={onClick}>
      <span style={styles.paginateLinkSymbol}>&#9668;</span>
      <span style={styles.paginateLinkItem}>Forrige</span>
    </div>
  ) : null;
};

const PaginationNext = ({ show, onClick }) => {
  const paginateItemNextStyle = {
    ...styles.paginateLinkItem,
    marginRight: 3
  };

  return show ? (
    <div style={styles.paginateLink as any} onClick={onClick}>
      <span style={paginateItemNextStyle}>Neste</span>
      <span style={styles.paginateLinkSymbol}>&#9658;</span>
    </div>
  ) : null;
};

export default Radium(pagination);
